import { Box, Stack, Typography } from '@mui/material';

import { FeatureItemProps } from './types';

function FeatureItem({ icon, title, description }: FeatureItemProps) {
  return (
    <Stack gap={1}>
      <Stack direction="row" gap={1.5} alignItems="top">
        <Box mt={0.3}>{icon}</Box>
        <Typography variant="h5">
          {title}{' '}
          <Typography color="text.muted" component="span">
            {description}
          </Typography>
        </Typography>
      </Stack>
    </Stack>
  );
}

export default FeatureItem;
